// Где открыт фронтенд: на сайте или в Telegram Mini App. Экраны одни, меняется обвязка:
// главное действие, «назад», вход, ссылки наружу.
import { createContext, useContext, type ReactNode } from "react";
import type { TelegramWebApp } from "./telegramTypes";

export type Channel = { kind: "site" } | { kind: "telegram"; webApp: TelegramWebApp };

const SITE: Channel = { kind: "site" };
const ChannelContext = createContext<Channel>(SITE);

export function ChannelProvider({
  webApp,
  children,
}: {
  webApp: TelegramWebApp | null;
  children: ReactNode;
}) {
  const channel: Channel = webApp === null ? SITE : { kind: "telegram", webApp };
  return <ChannelContext.Provider value={channel}>{children}</ChannelContext.Provider>;
}

export function useChannel(): Channel {
  return useContext(ChannelContext);
}

export function useIsMiniApp(): boolean {
  return useChannel().kind === "telegram";
}

// Ссылка наружу: в Mini App — во внешнем браузере через Telegram, на сайте — новой вкладкой.
export function useOpenExternalLink(): (url: string) => void {
  const channel = useChannel();
  return (url: string) => {
    if (channel.kind === "telegram") {
      channel.webApp.openLink(url);
      return;
    }
    window.open(url, "_blank", "noopener");
  };
}
